import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormCheckbox, useZionFormContext } from '@fs/zion-form'
import { Separator, Row } from '@fs/zion-ui'
import LegalText from '../../components/footer/LegalText'
import RequiredText from '../../components/dashboard/components/content-forms/RequiredText'

const privacyTermsName = 'privacyTerms'

export default function AgreePrivacyTermsField() {
  const [t] = useTranslation()
  const { formState } = useZionFormContext()
  const { errors } = formState
  const error = errors[privacyTermsName]
  return (
    <>
      <FormCheckbox
        name={privacyTermsName}
        label={`* ${t(
          'conference-announce.subscribe.privacy.terms',
          'I agree to the FamilySearch Terms of Use and have read the Privacy Notice.'
        )}`}
        required
      />
      <Separator size="nano" />
      <Row>
        <div />
        <LegalText centered={false} hideExtraText />
      </Row>
      {error && <RequiredText inputId={privacyTermsName}>{error.message}</RequiredText>}
    </>
  )
}
